module.exports = __webpack_public_path__ + "assets/img/solution3.5b31a7cb.png";